import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-delete-master-categories-product',
  templateUrl: './delete-master-product.component.html',
  styleUrls: ['./delete-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']
})

export class DeleteMasterProductComponent {
 
  @Output() confirmDelete: EventEmitter<string> = new EventEmitter<string>();

  constructor( public dialogRef: MatDialogRef<DeleteMasterProductComponent>,){}

  onClose(): void {
    // while close child to parent props as undefined keyword
    this.dialogRef.close();
  }

  confirmClose(): void {
    // while close child to parent props as confirm keyword
    this.dialogRef.close('confirm');
  }

  cancel(): void {
    // while close child to parent props as cancel keyword
    this.dialogRef.close('cancel');
  }

}
